import { Context, Config, Plugins } from '@leverege/plugin';
import { AllowedReducer } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import { Dialogs } from '@leverege/ui-elements';
import Molten from '@leverege/molten';
import { LoadingView } from '@leverege/molten/views';
import { DataSources } from '@leverege/ui-attributes';
import PairKeysToVehicle from './PairKeysToVehicle';
import { canPairKeysToVehicle } from '../../util/Interface';
export default function PairKeys(molten) {
  return {
    id: 'recovr.vehicle.pairKeysToVehicle',
    name: 'Pair Key to Vehicle',
    layout: {
      sort: 'pair.pairKeysToVehicle'
    },
    matches: [{
      use: ['contextMenu', 'mobileActionBar'],
      path: 'company.locations.vehicles',
      objectType: 'vehicle'
    }, {
      use: ['contextMenu', 'mobileActionBar'],
      path: 'location.vehicles',
      objectType: 'vehicle'
    }],
    appearance: props => {
      const {
        context
      } = props;
      const {
        target
      } = context;
      const vin = target?.[0]?.data?.data?.vin;
      return {
        icon: Config.get('PairKeys', 'icon', 'fa-kit fa-lv-vehicle-keys'),
        name: Config.get('PairKeys', 'title', `Pair Keys to ${vin || 'Vehicle'}`)
      };
    },
    prepare: async cxt => {
      const {
        clientProps
      } = cxt;
      const targets = Context.getTargetsOfType(cxt, 'vehicle');
      const device = clientProps.items?.items?.[0];
      const vehicleId = targets?.[0]?.id || device?.id;
      const companyId = targets?.[0]?.data?.data?.company?.id || device?.data?.company?.id;
      const locationId = targets?.[0]?.data?.data?.location?.id || device?.data?.location?.id;
      if (targets?.length > 1) {
        return false;
      }
      return canPairKeysToVehicle({
        companyId,
        locationId,
        vehicleId
      });
    },
    isPrepared: cxt => {
      const {
        clientProps
      } = cxt;
      const targets = Context.getTargetsOfType(cxt, 'vehicle');
      const device = clientProps.items?.items?.[0];
      const vehicleId = targets?.[0]?.id || device?.id;

      // when on location, check whether location has keys enabled attribute or not
      const keysEnabled = clientProps.parentItem?.data?.data?.keysEnabled;
      if (targets?.length > 1 || !keysEnabled) {
        return true;
      }
      const a = AllowedReducer.get(GlobalState.get(), vehicleId);
      return a.pairKeysToVehicle != null;
    },
    handles: cxt => {
      const {
        clientProps
      } = cxt;
      const targets = Context.getTargetsOfType(cxt, 'vehicle');
      const device = clientProps.items?.items?.[0];
      const vehicleId = targets?.[0]?.id || device?.id;
      if (targets?.length > 1) {
        return false;
      }
      const a = AllowedReducer.get(GlobalState.get(), vehicleId);
      return a.pairKeysToVehicle === true;
    },
    perform: async props => {
      const {
        context
      } = props;
      const {
        clientProps
      } = context;
      const systemId = Molten.getConfig('api/systemId');

      // target used if no vehicles are selected by selecting the first vehicle in the location
      const target = clientProps.items?.items?.[0];
      const device = Context.getTargetsOfType(context, 'vehicle')?.[0];
      const deviceId = device?.id;
      const deviceVin = device?.data?.data?.vin;
      const parentNetworkId = target?.data?.networkId;
      let actions;
      if (device) {
        actions = DataSources.getActions(device).parent();
      } else {
        actions = clientProps.actions;
      }
      const companyId = device?.data?.data?.company?.id || target?.data?.company?.id;
      const locationId = device?.data?.data?.location?.id || target?.data?.location?.id;

      // api call to get any existing paired keys of given vehicle
      const getVehicleKeys = async (actions, vehicleId) => {
        let vehicleKeys;
        try {
          vehicleKeys = (await GlobalState.dispatch(actions.item(`${vehicleId}`).child('keys').list())).items.map(key => ({
            keyId: key.data.keyId,
            imagine: key
          }));
        } catch (err) {
          console.error('Error fetching keys from vehicle', err);
        }
        if (!vehicleKeys.length) {
          vehicleKeys = [{
            keyId: null,
            imagine: null
          }];
        }
        return vehicleKeys;
      };

      // get all keys already paired to vehicle, or initialize it if none
      let deviceKeys;
      if (device) {
        const closeLoading = LoadingView.showDialog('Loading vehicle details');
        deviceKeys = await getVehicleKeys(actions, deviceId);
        closeLoading();
      } else {
        deviceKeys = [{
          keyId: null,
          imagine: null
        }];
      }

      // creates the form to create new keys or vehicles
      const factory = Plugins.getFactory('BlueprintForm');
      const AddDeviceForm = addProps => {
        const {
          blueprintType,
          createBlueprintName
        } = addProps;
        return factory.create(`${blueprintType}.create`, {
          target: {
            type: blueprintType,
            data: {}
          },
          title: createBlueprintName,
          submitText: createBlueprintName,
          eventData: props,
          pairing: true,
          ...addProps
        });
      };
      Dialogs.show({
        id: 'pairKeysToVehicle',
        component: PairKeysToVehicle,
        props: {
          actions,
          device,
          deviceId,
          deviceVin,
          deviceKeys,
          systemId,
          companyId,
          locationId,
          parentNetworkId,
          context,
          titleVariant: 'dialogTitle',
          AddDeviceForm,
          getVehicleKeys
        }
      });
    }
  };
}